export default __webpack_public_path__ + "static/media/OpenSans-LightItalic.f7713dca.woff";